import { Box, Container, alpha, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { GuestHeader } from './GuestHeader';

type Props = {
  children: ReactNode;
  eventName?: string;
  eventCode?: string;
};

export function GuestPageShell({ children, eventName }: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        color: 'common.white',
        backgroundImage: `
          linear-gradient(155deg, ${alpha(theme.palette.primary.dark, 0.38)} 0%, transparent 50%),
          radial-gradient(circle at 92% 4%, ${alpha(theme.palette.secondary.dark, 0.28)} 0%, transparent 30%),
          radial-gradient(circle at 10% 72%, ${alpha(theme.palette.warning.dark, 0.16)} 0%, transparent 28%),
          repeating-linear-gradient(135deg, ${alpha(theme.palette.common.white, 0.025)} 0 1px, transparent 1px 18px)
        `,
        backgroundColor: '#0B1120',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: { xs: 72, sm: 96 },
          right: { xs: -180, sm: -130 },
          left: { xs: '40%', sm: '48%' },
          height: { xs: 260, sm: 340 },
          pointerEvents: 'none',
          background: `linear-gradient(112deg, transparent 0 18%, ${alpha(theme.palette.secondary.light, 0.12)} 18% 28%, transparent 28% 42%, ${alpha(theme.palette.warning.light, 0.1)} 42% 51%, transparent 51%)`,
          transform: 'skewY(-8deg)',
        },
      }}
    >
      <GuestHeader eventName={eventName} />
      <Container maxWidth="sm" sx={{ position: 'relative', zIndex: 1, py: { xs: 2.25, sm: 4 }, px: { xs: 2, sm: 3 } }}>
        {children}
      </Container>
    </Box>
  );
}
